import { Box, LinearProgress } from '@mui/material';

export type PageToolbarLinearProgressProps = {
  /** When false, the bar fades out without affecting toolbar layout (absolute positioning + opacity). */
  visible: boolean;
};

/**
 * Indeterminate progress line along the bottom edge of {@link PageToolbar}.
 * Absolutely positioned so toggling visibility does not shift content below the toolbar.
 */
export function PageToolbarLinearProgress({ visible }: PageToolbarLinearProgressProps) {
  return (
    <Box
      sx={{
        position: 'absolute',
        width: '100%',
        left: 0,
        bottom: -4,
        opacity: visible ? 1 : 0,
        transition: 'opacity 0.2s ease-in-out',
        pointerEvents: 'none',
      }}
    >
      <LinearProgress />
    </Box>
  );
}
